// cookieManager.js
class CookieManager {
    constructor() {
      this.cookieConsent = {
        essential: true, // Always true as these are required
        analytics: false,
        marketing: false,
        thirdparty: false
      };
      
      this.initialized = false;
      this.consentVersion = "1.0"; // Increment when changing consent options

         // Add this flag to disable ads during development
         this.adsDisabled = false; // Set to false when you're ready to implement ads
    }
    
    init() {
      if (this.initialized) return;
      
      // Check for existing consent
      const savedConsent = localStorage.getItem("cookieConsent");
      const savedVersion = localStorage.getItem("consentVersion");
      
      if (savedConsent && savedVersion === this.consentVersion) {
        try {
          this.cookieConsent = JSON.parse(savedConsent);
          this.initialized = true;
          
          // Initialize services based on consent
          this.applyConsent();
          
          // Hide banner
          const cookieBanner = document.getElementById("cookie-banner");
          if (cookieBanner) {
            cookieBanner.style.display = "none";
          }
        } catch (e) {
          console.error("Error parsing saved cookie consent", e);
          this.showBanner();
        }
      } else {
        this.showBanner();
      }
    }
    
    showBanner() {
      const banner = document.getElementById("cookie-banner");
      if (banner) {
        banner.style.display = "block";
        
        // Set checkbox states based on current consent
        document.getElementById("analytics-cookies").checked = this.cookieConsent.analytics;
        document.getElementById("marketing-cookies").checked = this.cookieConsent.marketing;
        document.getElementById("thirdparty-cookies").checked = this.cookieConsent.thirdparty;
        
        // Set up event listeners
        this.setupEventListeners();
      }
    }
    
    setupEventListeners() {
      document.getElementById("cookie-accept-btn").addEventListener("click", () => {
        this.cookieConsent = {
          essential: true,
          analytics: true,
          marketing: true,
          thirdparty: true
        };
        this.saveConsent();
      });
      
      document.getElementById("cookie-reject-btn").addEventListener("click", () => {
        this.cookieConsent = {
          essential: true,
          analytics: false,
          marketing: false,
          thirdparty: false
        };
        this.saveConsent();
      });
      
      document.getElementById("cookie-save-btn").addEventListener("click", () => {
        this.cookieConsent = {
          essential: true,
          analytics: document.getElementById("analytics-cookies").checked,
          marketing: document.getElementById("marketing-cookies").checked,
          thirdparty: document.getElementById("thirdparty-cookies").checked
        };
        this.saveConsent();
      });
    }
    
    saveConsent() {
      localStorage.setItem("cookieConsent", JSON.stringify(this.cookieConsent));
      localStorage.setItem("consentVersion", this.consentVersion);
      
      document.getElementById("cookie-banner").style.display = "none";
      this.initialized = true;
      
      // Apply consent to services
      this.applyConsent();
    }
    
    applyConsent() {
      // Initialize services based on consent
      if (this.cookieConsent.analytics) {
        this.initAnalytics();
      }
      
      if (this.cookieConsent.marketing) {
        this.initMarketing();
      }
      
      if (this.cookieConsent.thirdparty) {
        this.initThirdParty();
      }
    }
    
    // Set actual cookies with proper security settings
    setCookie(name, value, days) {
      const secure = location.protocol === 'https:' ? '; Secure' : '';
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = "; expires=" + date.toUTCString();
      document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax" + secure;
    }
    
    // Get cookie value by name
    getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
    
    // Delete cookie by name
    deleteCookie(name) {
      document.cookie = name + '=; Path=/; SameSite=Lax; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
    
    // Initialize analytics (Google Analytics)
    initAnalytics() {
        if (this.adsDisabled) return;
      // Check if Google Analytics script exists
      if (!window.ga && this.cookieConsent.analytics) {
        // Add Google Analytics code here

        /* commented out for dev
        this.loadScript('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3380353766649546', () => {
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'YOUR-GA-ID', {
            'cookie_flags': 'SameSite=Lax;Secure'
          });
        });
        */
      }
    }
    
    // Initialize marketing (e.g., Google Ads)
    initMarketing() {
      if (this.cookieConsent.marketing) {
        // Add marketing pixel/code here
        this.setCookie("marketing_enabled", "true", 30);
      }
    }
    
    // Initialize third-party scripts (AdSense, etc.)
    initThirdParty() {
        if (this.adsDisabled) return;
      
        if (this.cookieConsent.thirdparty) {
           // Check if AdSense is already loaded
    if (window.adsbygoogle) {
        console.log('AdSense already initialized');
        return;
      }
    // Add AdSense code
    this.loadScript('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3380353766649546', () => {
        console.log('AdSense script loaded');
        // Don't push anything here - let AdSense initialize naturally
          });
        }
      }
    
    // Utility to load scripts dynamically
    loadScript(src, callback) {
      const script = document.createElement('script');
      script.async = true;
      script.src = src;
      
      if (callback) {
        script.onload = callback;
      }
      
      document.head.appendChild(script);
    }
    
    // Check if a specific type of cookie is allowed
    isAllowed(type) {
      return this.cookieConsent[type] === true;
    }
  }
  
  // Create a global instance
  const cookieManager = new CookieManager();
  
  // Export for module usage
  export default cookieManager;